function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable max-len */
import { Icon } from '@chakra-ui/icon';
import React from 'react';
export var CheckIcon = props => /*#__PURE__*/React.createElement(Icon, _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  fill: "currentColor",
  r: "12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 12.4501L10.2 15.1501L16.5 8.8501",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2"
})); // TODO: Check designs if used

export var InfoIcon = props => /*#__PURE__*/React.createElement(Icon, _extends({
  viewBox: "0 0 26 40"
}, props), /*#__PURE__*/React.createElement("ellipse", {
  cx: "13",
  cy: "19.9998",
  fill: "none",
  rx: "11.1429",
  ry: "10.8333",
  stroke: "currentColor",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("mask", {
  fill: "white",
  id: "path-2-inside-1"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M14.7142 13.3335H11.2856V16.6668H14.7142V13.3335ZM14.7142 18.3335H11.2856V26.6668H14.7142V18.3335Z",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M14.7142 13.3335H11.2856V16.6668H14.7142V13.3335ZM14.7142 18.3335H11.2856V26.6668H14.7142V18.3335Z",
  fill: "currentColor",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2856 13.3335V12.3335H10.2856V13.3335H11.2856ZM14.7142 13.3335H15.7142V12.3335H14.7142V13.3335ZM11.2856 16.6668H10.2856V17.6668H11.2856V16.6668ZM14.7142 16.6668V17.6668H15.7142V16.6668H14.7142ZM11.2856 18.3335V17.3335H10.2856V18.3335H11.2856ZM14.7142 18.3335H15.7142V17.3335H14.7142V18.3335ZM11.2856 26.6668H10.2856V27.6668H11.2856V26.6668ZM14.7142 26.6668V27.6668H15.7142V26.6668H14.7142ZM11.2856 14.3335H14.7142V12.3335H11.2856V14.3335ZM12.2856 16.6668V13.3335H10.2856V16.6668H12.2856ZM14.7142 15.6668H11.2856V17.6668H14.7142V15.6668ZM13.7142 13.3335V16.6668H15.7142V13.3335H13.7142ZM11.2856 19.3335H14.7142V17.3335H11.2856V19.3335ZM12.2856 26.6668V18.3335H10.2856V26.6668H12.2856ZM14.7142 25.6668H11.2856V27.6668H14.7142V25.6668ZM13.7142 18.3335V26.6668H15.7142V18.3335H13.7142Z",
  fill: "currentColor",
  mask: "url(#path-2-inside-1)"
}));
export var ErrorIcon = props => /*#__PURE__*/React.createElement(Icon, _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  fill: "currentColor",
  r: "12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 7V13.5",
  stroke: "white",
  strokeLinecap: "round",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "17",
  fill: "white",
  r: "1"
}));
export var WarningIcon = props => /*#__PURE__*/React.createElement(Icon, _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.0404 1.67936C11.4647 0.936833 12.5353 0.936833 12.9596 1.67936L23.0551 19.3464C23.4761 20.0832 22.9441 21 22.0954 21H1.90457C1.05592 21 0.523884 20.0832 0.94493 19.3464L11.0404 1.67936Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.3576 15.808L10.6996 9.116L13.3036 9.13L12.6316 15.808H11.3576ZM10.8676 16.76H13.1356V19H10.8676V16.76Z",
  fill: "white"
})); // Do not delete: icon with new exclamation point
// export const WarningIcon: React.FC<IconProps> = (props) => (
//   <Icon fill="none" viewBox="0 0 24 26" {...props}>
//     <path d="M11.0404 2.67937C11.4647 1.93683 12.5353 1.93683 12.9596 2.67937L23.0551 20.3464C23.4761 21.0832 22.9441 22 22.0954 22H1.90457C1.05592 22 0.523884 21.0832 0.94493 20.3464L11.0404 2.67937Z" fill="currentColor"/>
//     <path d="M12.158 10V15" stroke="white" strokeLinecap="round" strokeWidth="2"/>
//     <circle cx="12.158" cy="18" fill="white" r="1"/>
//   </Icon>
// )
//# sourceMappingURL=icons.js.map